import React, { FC } from 'react'
import { Box } from '@mui/material'
import { HourglassBottomTwoTone } from '@mui/icons-material'
import { useStyles } from '../../../../theme'

interface ILoaderProps {
  size?: 'medium' | 'large' | 'small' | 'inherit'
}

export const Loader: FC<ILoaderProps> = ({size='inherit'}) => {
  const styles= useStyles()
  return (
    <Box
      position="absolute"
      display="flex"
      sx={{
        top:0, left:0, right:0, bottom:0,
        background: 'rgba(0,0,0,0.05)',
        backdropFilter: 'blur(5px)',
      }}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
        <HourglassBottomTwoTone fontSize={size} color="primary" sx={styles.rotateIcon_wiggle} />
    </Box>
  )
}
